module.exports = __webpack_public_path__ + "img/鎏金面膜_05.bfc04342.jpg";